import { prettyPrintDate } from 'app/shared/formatting';
import { HttpService, ModalService } from 'app/services';
import { generateCsv } from 'app/shared/export-csv';
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const beginDate = new Date(Date.now() - (1 * 86400000)); //set to 1 day before
const today = new Date();
const dpOvBeginDate = new Date(Date.now() - (7 * 86400000));
const csvSafetyRegex = /(,)|(\n)|(    )|(#)/g;
dpOvBeginDate.setHours(0, 0, 0, 0);
beginDate.setHours(0, 0, 0, 0);
today.setHours(0, 0, 0, 0);

const styles = {
    defaultStyle: {
        fontSize: 9
    },
};

const layouts = {
    thinBorders: {
        hLineWidth: (i: any, node: any) => 1,
        vLineWidth: (i: any, node: any) => 1,
    },
    kindaLightBorders: {
        hLineColor: (i: any, node: any) => '#555555',
        vLineColor: (i: any, node: any) => '#555555'
    },
    lightBorders: {
        hLineColor: (i: any, node: any) => '#999999',
        vLineColor: (i: any, node: any) => '#999999'
    },
    reallyLightBorders: {
        hLineColor: (i: any, node: any) => '#DDDDDD',
        vLineColor: (i: any, node: any) => '#DDDDDD'
    }
};

const margins = {
    none: [0, 0, 0, 0],
    noBorder: [-5, 0, 0, 0],
    bottomBorder: [-5, 0, 0, 2]
};

const borders = {
    bottom: [false, false, false, true],
    none: [false, false, false, false]
};

const svgs = {
    warehouse: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path style="fill:#696969" d="M528 352H352V240c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM304 464H144v-64h160v64zm0-128H144v-64h160v64zm192 128H352v-64h144v64zm101.9-353.9L346.3 5.3c-17-7-35.7-7.1-52.6 0L42.1 110.1C16.5 120.7 0 145.5 0 173.2V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V173.2c0-8.3 4.9-15.7 12.5-18.8L312.2 49.6c5.1-2.1 10.6-2.1 15.7 0l251.6 104.8c7.6 3.2 12.5 10.6 12.5 18.8V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V173.2c0-27.7-16.5-52.5-42.1-63.1z"/></svg>',
    device: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path style="fill:#696969" d="M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-64 452c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v8zm64-80c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"/></svg>',
    tasks: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path style="fill:#696969" d="M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"/></svg>',
};

const footer = {
    text: 'Generated in SkyhawkEE • PICA Product Development, LLC ©2024',
    alignment: 'center',
    color: '#CCC',
    italics: true,
    fontSize: 8
};

const buildTextCell = (text: string, options?: any): any => {
    let cell: any = {};
    if (options?.borderBottom) {
        cell.border = borders.bottom;
        cell.margin = margins.bottomBorder;
        delete options.borderBottom;
    } else {
        cell.border = borders.none;
        cell.margin = margins.noBorder;
    }
    return {
        text: text,
        ...cell,
        ...(options || {})
    };
}

const buildSvgCell = (svg: string, options?: any): any => {
    let cell: any = {};
    if (options?.borderBottom) {
        cell.border = borders.bottom;
        cell.margin = margins.bottomBorder;
        delete options.borderBottom;
    } else {
        cell.border = borders.none;
        cell.margin = margins.noBorder;
    }
    return {
        svg: svg,
        ...cell,
        ...(options || {})
    };
};

const buildHeader = (obj: any): any => {
    return {
        layout: {
            ...layouts.thinBorders,
            ...layouts.kindaLightBorders
        },
        table: {
            headerRows: 2,
            widths: ['*', 45],
            heights: [15, 'auto'],
            body: [
                [
                    buildTextCell(`${obj._title} (${obj._beginDate ? (prettyPrintDate(obj._beginDate) + ' - ') : ''}${prettyPrintDate(obj._endDate)})`, {
                        fontSize: 14
                    }),
                    buildSvgCell(obj._svg, {
                        fit: [45, 30],
                        rowSpan: 2,
                        bottomBorder: true
                    })
                ],
                [
                    buildTextCell(obj._businessName, {
                        italics: true,
                        fontSize: 9,
                        borderBottom: true,
                        colSpan: 2
                    }),
                    {}
                ]
            ]
        }
    }
};

export class ReportGenerator {
    reports: any = [
        {
            textLabel: 'Deployment Details',
            id: 'DeploymentDetails',
            iframe: null,
            generateContent: 'loadDeploymentDetailsReport',
            exportCsv: 'loadDeploymentDetailsCsv',
            initialFilterProps: { from: beginDate, },
            filterProps: {},
            modalKey: 'showCustomizeDeploymentDetailsReportModal',
            loading: true,
        },
        {
            title: 'Seven Day Deployment Report',
            textLabel: 'Deployment Overview',
            id: 'DeploymentOverview',
            iframe: null,
            svg: svgs.warehouse,
            generateContent: 'deploymentOverviewContent',
            generateRows: 'deploymentOverviewRows',
            exportCsv: true,
            loading: true,
            initialFilterProps: { beginDate: dpOvBeginDate },
            data: <any>{}
        },
        {
            title: 'Device Alert Report',
            textLabel: 'Device Alerts',
            id: 'DeviceAlerts',
            iframe: null,
            svg: svgs.device,
            initialFilterProps: {
                beginDate: beginDate,
            },
            modalKey: 'showCustomizeDevicesReportModal',
            filterProps: null,
            filter: ((el: any) => {
                let _ = this.reports.DeviceAlerts.filterProps || this.reports.DeviceAlerts.initialFilterProps;
                if (_.hideHubs && (el.device_serial || el.sensor_serial).match(/SHH.*/)) {
                    return false;
                }
                if (_.users?.length)
                    if (!_.users.find((j: any) => j == el.user_id))
                        return false;
                if (_.devices?.length)
                    if (!_.devices.find((j: any) => j == el.deviceId))
                        return false;
                if (_.locations?.length)
                    if (!_.locations.find((j: any) => this.activeSegPesttrapData.find((k: any) => k.ext_cus_location_id == j && k.device_id == el.deviceId)))
                        return false;
                if (_.beginDate?.getTime() > (new Date(el.date)).getTime())
                    return false;
                if (_.endDate?.getTime() < (new Date(el.date)).getTime())
                    return false;
                if (_.events?.length) {
                    let eventMatch = false;
                    let body = el?.body?.toLowerCase();
                    for (let i of _.events) {
                        if (eventMatch)
                            break;
                        else
                            switch (i) {
                                case 'magnetremoved':
                                    if (body.match(/(magnet|reed) remove/))
                                        eventMatch = true;
                                    break;
                                case 'magnetreplaced':
                                    if (body.match(/(magnet|reed) replace/))
                                        eventMatch = true;
                                    break;
                                case 'accel':
                                    if (body.match(/vibration/))
                                        eventMatch = true;
                                    break;
                                case 'pir':
                                    if (body.match(/pir\/ir triggered/))
                                        eventMatch = true;
                                    break;
                                case 'missedheartbeat':
                                    if (body.match(/miss.*heartbeat/))
                                        eventMatch = true;
                                    break;
                                default: '';
                            }
                    }

                    if (!eventMatch)
                        return false;
                }
                return true;
            }),
            generateContent: 'deviceAlertsContent',
            generateRows: 'deviceAlertsRows',
            exportCsv: true,
            loading: true,
            data: <any>{}
        },
        {
            title: 'System Verification Report',
            textLabel: 'System Verification Report',
            id: 'SystemVerificationReport',
            iframe: null,
            generateContent: 'systemVerificationReportContent',
            modalKey: 'showCustomizeSystemVerificationReportModal',
            exportCsv: 'loadVerificationReportCsv',
            loading: false,
            data: <any>{}
        }
    ];

    technicians: any = [];
    deployments: any = [];
    devices: any = [];
    events: any = [];
    activeSegPesttrapData: any = [];
    includeServiceMode: boolean = false;
    segPesttrapData: any;
    users: any;
    locations: any;
    _activeReport: any = {};
    optionsLoading: any;
    optionSelect: { customers: any, locations: any, users: any, devices: any } = {
        customers: null,
        locations: null,
        users: null,
        devices: null,
    };

    get DeploymentOverview() { return this.reports.DeploymentOverview; }
    get DeploymentDetails() { return this.reports.DeploymentDetails; }
    get DeviceAlerts() { return this.reports.DeviceAlerts; }
    get SystemVerificationReport() { return this.reports.SystemVerificationReport; }
    get activeReport() { return this._activeReport; }
    set activeReport(report) {
        if (typeof report == 'number') report = this.reports[report];

        report.loading = true;
        report.loadingCallback = (e: any) => {
            if (this.reportChange) this.reportChange();
            report.loading = false;
        };

        this._activeReport = report;
        this.generateReport(report).then(() => report.loadingCallback()).catch((err: any) => {
            report.loadingCallback();
            this.modalService.errorDialog(err);
        });
    }

    modalService: ModalService;
    httpService: HttpService;
    reportChange: () => void;
    businessName: string;

    constructor(_modalService: ModalService, _httpService: HttpService, _businessName: string, serviceMode: boolean, _reportChange: () => void) {
        this.reports.forEach((el: any) => {
            this.reports[el.textLabel] = el;
            this.reports[el.id] = el;
        });

        this.modalService = _modalService;
        this.businessName = _businessName;
        this.reportChange = _reportChange;
        this.httpService = _httpService;

        this.init(serviceMode);
    }

    init(serviceMode: boolean) {
        this.optionsLoading = new Promise((resolve, reject) => {
            try {
                const sortFn = (a: any, b: any) => {
                    return (
                        a.label.toLowerCase() > b.label.toLowerCase() ? 1 :
                            (a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 0)
                    );
                }

                Promise.all([
                    this.httpService.getSubaccountLocations().toPromise().then(res => {
                        res = res.filter((el: any) => !el.inactive);
                        if (res.length > 0 && res[0].locations && res[0].locations.length > 0) {
                            const defaultCustomerId = res[0].id;
                            const defaultLocationId = res[0].locations[0].id;
                            const verificationReport = this.reports['SystemVerificationReport'];
                            verificationReport.filterProps = {
                                customerId: defaultCustomerId,
                                locationId: defaultLocationId,
                                beginDate: beginDate
                            };

                            this.optionSelect.customers = res.map((el: any) => ({ value: el.id, label: el.name })).sort(sortFn);
                            this.optionSelect.locations = res.flatMap((el: any) => el.locations || []).map((el: any) => ({ value: el.id, label: el.name })).sort(sortFn);
                        }

                    }),
                    this.httpService.getBusinessUsers().toPromise().then(res => {
                        this.optionSelect.users = res.map((el: any) => ({ value: el.id, label: `${el.first_name} ${el.last_name}` })).sort(sortFn);
                    }),
                    Promise.all([
                        this.httpService.getBusinessHubSensors({ users: true, businessSubscription: true, sensorHistories: true, segPestTrapData: true }).toPromise(),
                        this.httpService.getBusinessDevices({ users: true, businessSubscription: true, sensorHistories: true, segPestTrapData: true, deviceEvents: true, locationTracking: true }).toPromise()
                    ]).then(res => {
                        let devices = [...res[0], ...res[1]];
                        this.optionSelect.devices = devices.map(el => ({ value: el.id, label: el.devicename })).sort(sortFn);
                    })
                ]).then(() => {
                    resolve(true);
                    this.optionsLoading = false;

                    if (this.includeServiceMode !== serviceMode) this.toggleServiceMode();
                });
            } catch (err) {
                reject(err);
                this.modalService.errorDialog(err);
            }
        });
    }

    isDeploymentTab(): boolean {
        return this.activeReport.id === 'DeploymentDetails' || this.activeReport.id === 'SystemVerificationReport';
    }

    loadDeploymentOverview(report: any): Promise<any> {
        let data: any = {}, locationsKey: any = {}, usersKey: any = {};

        return Promise.all([
            this.httpService.getSegPesttrapData(dpOvBeginDate).toPromise().then(res => data.segPesttrapData = res),
            this.httpService.getBusinessUsers().toPromise().then(res => {
                data.users = res;
                for (let user of data.users) {
                    if (user.first_name && user.last_name) user.fullName = `${user.first_name} ${user.last_name}`;
                    else user.fullName = '[User not found]';

                    usersKey[user.id] = user;
                }
            }),
            this.httpService.getSubaccountLocations().toPromise().then(res => {
                for (let customer of res) {
                    if (customer.locations) {
                        for (let location of customer.locations) location.customerName = customer.name;
                    }
                }

                data.locations = res.flatMap((el: any) => el.locations || []);
                for (let location of data.locations) {
                    location.total_alerts = 0;
                    location.segPesttrapData = [];
                    locationsKey[location.id] = location;
                }
            })
        ]).then(() => {
            for (let location of data.locations) {
                let techniciansObj: any = {};

                location.segPesttrapData = data.segPesttrapData.filter((el: any) => el.ext_cus_location_id == location.id);
                location.initial_deploy_time = data.segPesttrapData[0]?.deploy_time;

                if (!data.segPesttrapData.find((el: any) => el.pickup_time == null)) {
                    let pickupSort = data.segPesttrapData.sort((a: any, b: any) =>
                        a.pickup_time > b.pickup_time ? 1 : a.pickup_time < b.pickup_time ? -1 : 0
                    );

                    location.final_pickup_time = pickupSort[pickupSort.length - 1];
                }

                for (let i = 0; i < location.segPesttrapData.length; i++) {
                    if (location.segPesttrapData[i].total_alerts) location.total_alerts += location.segPesttrapData[i].total_alerts;
                    if (!techniciansObj[location.segPesttrapData[i].user_id]) {
                        techniciansObj[location.segPesttrapData[i].user_id] = usersKey[location.segPesttrapData[i].user_id]?.fullName || '[User not found]';
                    }
                }

                location.technicians = Object.values(techniciansObj).sort();
            }

            data.locations = data.locations?.sort((a: any, b: any) => {
                return (
                    a.name?.toLowerCase() > b.name?.toLowerCase() ? 1 :
                        (a.name?.toLowerCase() < b.name?.toLowerCase() ? -1 : 0)
                );
            });

            return data;
        });
    }

    loadDevices(report: any) {
        let data = [], devices: any = [], sensors: any = [], sptd: any = [], units = [], locs: any = [];
        let evFilter;

        if (report.filterProps?.endDate || report.initialFilterProps?.endDate) {
            evFilter = {
                where: {
                    created: {
                        between: [
                            (report.filterProps?.beginDate || report.initialFilterProps?.beginDate || beginDate).getTime(),
                            (report.filterProps?.endDate || report.initialFilterProps?.endDate).getTime()
                        ]
                    }
                }
            };
        } else {
            evFilter = {
                where: {
                    created: {
                        gt: (report.filterProps?.beginDate || report.initialFilterProps?.beginDate || beginDate).getTime()
                    }
                }
            };
        }

        return Promise.all([
            this.httpService.getBusinessDevices({ segPestTrapData: true, businessSubscription: true, locationTracking: true }, evFilter).toPromise().then(res => devices = res),
            this.httpService.getBusinessHubSensors({ segPestTrapData: true, businessSubscription: true }, evFilter).toPromise().then(res => sensors = res),
            this.httpService.getSegPesttrapData(null, null, true).toPromise().then(res => sptd = res),
            this.httpService.getSubaccountLocations().toPromise().then(res => locs = res)
        ]).then(() => {
            this.activeSegPesttrapData = sptd;
            units = [...devices, ...sensors];
            units.sort((a, b) => {
                const nameA = a.devicename?.toUpperCase();
                const nameB = b.devicename?.toUpperCase();
                return nameA < nameB ? -1 : +(nameA > nameB) || 0;
            });

            let events: any = [];
            units.forEach(unit => {
                unit.key = unit.sensorHistories ? 'sensorHistories' : 'deviceEvents';
                if (unit[unit.key])
                    if (unit[unit.key].length > 0) {
                        unit.name = unit.devicename;
                        unit.events = unit[unit.key].filter((el: any) => !/.* just checked-in.*/.test(el.body));
                        unit.events.forEach((event: any) => {
                            event.date = new Date(event.created);
                            event.deviceName = unit.devicename;
                            event.deviceSerial = (unit.sensor_serial || unit.device_serial);
                            event.deviceId = unit.id;
                            event.createdLabel = prettyPrintDate(event.created, { time: true });
                            event.technician = unit.user_id;

                            //Look up and add customer, location into the event
                            let pdRecord = sptd.find((pd: any) => pd.device_serial === event?.deviceSerial);
                            let customer = locs.find((l: any) => l.id === pdRecord?.ext_cusid);
                            if (customer) {
                                event.customer = customer.name;
                                if (customer.locations && customer.locations.length > 0) {
                                    let location = customer.locations.find((l: any) => l.id === pdRecord.ext_cus_location_id)
                                    if (location) {
                                        event.location = location.name
                                    }
                                }
                            }

                        });

                        events.push(...unit.events);
                        this.devices.push(unit);
                    }
            });

            data = events;
            return data;
        });
    }

    async deploymentOverviewContent(report: any) {
        report.data = await this.loadDeploymentOverview(report);
        return report.data.locations.filter((el: any) => el.segPesttrapData?.length > 0).flatMap((el: any) => [{
            widths: ['*', '*'],
            columns: [{
                layout: {
                    ...layouts.reallyLightBorders,
                    ...layouts.thinBorders
                },
                table: {
                    headerRows: 1,
                    widths: ['auto', '*'],
                    body: [
                        [buildTextCell(el.name, {
                            fontSize: 11,
                            colSpan: 2,
                            borderBottom: true
                        }), {}],
                        [buildTextCell('Customer'), buildTextCell(el.customerName || 'N/A')],
                        [buildTextCell('Technician(s)'), buildTextCell(el.technicians.length > 1 ?
                            "Multiple" : el.technicians.length ?
                                el.technicians[0] : "N/A"
                        )],
                        [buildTextCell('Initial deployment date'), buildTextCell(el.initial_deploy_time ?
                            prettyPrintDate(el.initial_deploy_time, { time: true }) : 'N/A'
                        )],
                        [buildTextCell('Final pickup time'), buildTextCell(el.final_pickup_time ?
                            prettyPrintDate(el.final_pickup_time, { time: true }) : 'N/A'
                        )],
                        [buildTextCell('Total alerts (last 7 days)  '), buildTextCell(el.total_alerts || '0')]
                    ]
                }
            }, '']
        }, ' ']);
    }

    async deviceAlertsContent(report: any) {
        report.data = await this.loadDevices(report);
        let filteredData = report.data.filter(report.filter);
        let headerRow = (cells: any) => cells.map((el: any) => ({
            text: el,
            bold: true,
            border: [false, false, false, true, false, false]
        })), rows = [], j = 0;

        //Get unique customers
        let uniqueCustomers = [...new Set(filteredData.map((item: any) => item.customer))];
        uniqueCustomers = uniqueCustomers.sort();

        //Sort by customer Ascending 
        filteredData.sort((a: any, b: any) => {
            if (a.customer > b.customer) return 1;
            if (a.customer < b.customer) return -1;
            return 0;
        });

        //Then sort by location (sort locations group by customer) Ascending 
        let newFilteredData: any = [];
        for (let i = 0; i < uniqueCustomers.length; i++) {
            let customerFilterData = filteredData.filter((c: any) => c.customer === uniqueCustomers[i]);
            customerFilterData.sort((a: any, b: any) => {
                if (a.location > b.location) return 1;
                if (a.location < b.location) return -1;
                return 0;
            });
            newFilteredData = [...newFilteredData, ...customerFilterData]
        }

        filteredData = newFilteredData;
        for (let i = 0; i < filteredData.length; i++) {
            let options = {
                fillColor: (i % 2) ? '#CCC' : undefined,
                borders: (filteredData.length > (i + 1) && filteredData[i + 1].deviceSerial != filteredData[i].deviceSerial) ? [false, false, false, true, false, false] : [false, false, false, false, false, false]
            };

            //Remove Customer and Location out of the Alert.
            let data = filteredData[i].body.split("\n");
            if (data && data.length > 2) {
                for (let x = 0; x < data.length; x++) {
                    if (data[x].includes("Customer:") || data[x].includes("Location:")) {
                        filteredData[i].body = filteredData[i].body.replace("\n" + data[x], '');
                    }
                }
            }

            rows.push([
                { text: filteredData[i].deviceSerial, border: options.borders, fillColor: options.fillColor },
                { text: filteredData[i].deviceName, border: options.borders, fillColor: options.fillColor },
                { text: filteredData[i].createdLabel, border: options.borders, fillColor: options.fillColor },
                { text: filteredData[i].body.replace(/^\n/, ''), border: options.borders, fillColor: options.fillColor },
                { text: filteredData[i].customer, border: options.borders, fillColor: options.fillColor },
                { text: filteredData[i].location, border: options.borders, fillColor: options.fillColor },
            ]);
        }

        return [{
            layout: {
                hLineWidth: () => 2
            },
            table: {
                headerRows: 1,
                widths: ['auto', 'auto', 'auto', '*', 'auto', 'auto'],
                body: [headerRow(['Device', 'Name', 'Time', 'Alert', 'Customer', 'Location']), ...rows]
            }
        }];
    }

    async deviceAlertsRows(report: any) {
        let filteredData = await report.data.filter(report.filter);
        let rows = [
            ['Device', 'Name', 'Time', 'Alert'],
            ...filteredData.map((el: any) => [
                el.deviceSerial,
                el.deviceName,
                el.createdLabel,
                el.body
            ])
        ];

        return rows;
    }

    async deploymentOverviewRows(report: any) {
        let filteredData = report.data.locations.filter((el: any) => el.segPesttrapData?.length > 0),
            rows = [
                ['Location', 'Customer', 'Technician(s)', 'Initial deployment date', 'Final pickup time', 'Total alerts (Last 7 days)'],
                ...filteredData.map((el: any) => [
                    el.name,
                    el.customerName,
                    el.technicians && el.technicians[0] ? el.technicians[1] ? 'Multiple' : el.technicians[0] : '[technician not found]',
                    el.initial_deploy_time ? prettyPrintDate(el.initial_deploy_time, { time: true }) : 'N/A',
                    el.final_pickup_time ? prettyPrintDate(el.final_pickup_time, { time: true }) : 'N/A',
                    el.total_alerts ? el.total_alerts : '0'
                ])
            ];
        return rows;
    }


    async systemVerificationReportContent(report: any) {
        report.data = await this.loadVerificationData(report);
        let headerRow = (cells: any) => cells.map((el: any) => ({
            text: el,
            bold: true,
            border: [false, false, false, true],
        }));

        return report.data.map((el: any) => {
            return [{
                layout: { hLineWidth: () => 2 },
                table: {
                    headerRows: 1,
                    widths: ['auto', 'auto', 'auto', 'auto'],
                    body: [
                        headerRow(['Event', 'Status', 'Timestamp', 'Technician']),
                        ...el.events.map((event: any) => [
                            { text: event.type, border: [false, false, false, false] },
                            { text: event.status, border: [false, false, false, false] },
                            { text: prettyPrintDate(event.timestamp, { time: true }), border: [false, false, false, false] },
                            { text: event.technician || '[Technician Not Found]', border: [false, false, false, false] },
                        ]),
                    ],
                },
            }];
        });
    }

    injectIframe(report: any) {
        let container = document.querySelector(`div[id=reports-pdf-view]`);
        if (!container) return;

        if (container.children[0]) container.children[0].remove();
        let iframe = document.createElement('iframe');
        iframe.classList.add('report-iframe', report.id);
        container.appendChild(iframe);

        iframe.addEventListener("load", e => report.loadingCallback(e));
        report.iframe = iframe;

        return iframe;
    }

    customizeReport(report?: any): void {
        if (!report) report = this.activeReport;

        let savedProps = report.filterProps || {};
        if (!savedProps.beginDate) savedProps.beginDate = beginDate;

        (this.modalService as any)[report.modalKey](this.optionSelect, savedProps).afterClosed().subscribe((res: any) => {
            //pass `true` to reset, or an object of {[filterProperties]: [values]}
            if (!res) return;
            if (res === true) res = report.initialFilterProps;
            else {
                Object.entries(res).forEach(el => {
                    let [key, val] = el;
                    if (typeof val === undefined)
                        delete res[key];
                    else if (Array.isArray(val) && val.length == 0)
                        delete res[key];
                    else if (val instanceof Date) {
                        if (key === 'to') val.setHours(23, 59, 59, 999);
                        else val.setHours(0, 0, 0, 0);

                        if (val.getTime() > Date.now())
                            delete res[key];
                    }
                })
            }

            report.filterProps = res;
            this.activeReport = report;
        });
    }

    async shareReport() {
        let blob: any = (
            this.activeReport.blob ?
                this.activeReport.blob :
                await new Promise((res, rej) => {
                    this.activeReport.pdf.getBlob((blob: any) => res(blob));
                })
        );

        let file = new File([blob], (this.activeReport.filename || `Skyhawk - ${this.activeReport.title}.pdf`), { type: blob.type });
        let shareData: any = {
            text: this.activeReport.title,
            files: [file],
        };

        let nav: any = navigator;
        if (!nav.canShare || !nav.canShare(shareData)) {
            return this.modalService.showModal('Unsupported', 'Sharing is not supported by this browser. Please download the report and share it through your email client.');
        }

        await navigator.share(shareData);
    }

    async exportCsv(report?: any) {
        if (!report) report = this.activeReport;

        if (typeof report.exportCsv == 'string') return (this as any)[report.exportCsv](report);
        let rows = await (this as any)[report.generateRows](report);
        generateCsv(rows, true, `Skyhawk ${report.textLabel} ${prettyPrintDate({ fs: true })}`);
    }

    toggleServiceMode(): void {
        this.includeServiceMode = !this.includeServiceMode;

        if (this.activeReport) {
            this.generateReport(this.activeReport);
        }
    }

    async loadDeploymentDetailsReport(report: any): Promise<any> {
        let from = new Date(report.filterProps.from || report.initialFilterProps.from || 0).getTime(),
            to = new Date(report.filterProps.to || Date.now()).getTime(),
            customerIds = report.filterProps.customerIds || undefined,
            locationIds = report.filterProps.locationIds || undefined,
            inactiveFilter = report.filterProps.inactiveFilter || undefined;

        this.httpService.getDeploymentDetailsReport(from, to, customerIds, locationIds, inactiveFilter, this.includeServiceMode).toPromise().then((res: any) => {
            report.iframe = this.injectIframe(report);
            report.filename = res.headers.get('content-disposition').replace(/.*filename="(.+?)".*/, '$1');
            report.blob = new Blob([res.body], { type: 'application/pdf' });
            report.iframe.src = window.URL.createObjectURL(res.body);
        }).catch(error => {
            console.error('Error generating deployment details report:', error);
            this.modalService.errorDialog(error);
        });
    }

    async loadVerificationData(report: any): Promise<any> {
        if (this.optionsLoading) await this.optionsLoading;

        const from = report.filterProps?.beginDate || beginDate;
        from.setHours(0, 0, 0, 0);

        let n = new Date();
        let to = report.filterProps?.endDate || n;

        if (to.toDateString() !== n.toDateString() && to < n) to.setHours(23, 59, 59, 999);
        else to = n;

        const locationId = report.filterProps?.locationId;
        const customerId = report.filterProps?.customerId;

        if (!locationId || !customerId) {
            if (this.optionSelect.locations?.length && this.optionSelect.customers?.length)
                this.customizeReport(this.activeReport);
            else {
                delete this.activeReport.modalKey;
                delete this.activeReport.generateContent;
                delete this.activeReport.exportCsv;
            }

            return;
        }

        return this.httpService.generateVerificationReport(from.getTime(), to.getTime(), customerId, locationId, this.includeServiceMode).toPromise().then(res => {
            report.iframe = this.injectIframe(report);
            report.filename = res.headers.get('content-disposition')?.replace(/.*filename="(.+?)".*/, '$1');
            report.blob = new Blob([res.body as Blob], { type: 'application/pdf' });
            report.iframe.src = window.URL.createObjectURL(res.body as Blob);
        }).catch(error => {
            console.error('Error generating verification report:', error);
            this.modalService.errorDialog(error);
        });
    }

    async loadDeploymentDetailsCsv(report: any): Promise<any> {
        let from = new Date(report.filterProps.from || report.initialFilterProps.from || 0).getTime(),
            to = new Date(report.filterProps.to || Date.now()).getTime(),
            customerIds = report.filterProps.customerIds || undefined,
            locationIds = report.filterProps.locationIds || undefined,
            inactiveFilter = report.filterProps.inactiveFilter || undefined;

        this.httpService.getDeploymentDetailsCsv(from, to, customerIds, locationIds, inactiveFilter, this.includeServiceMode).toPromise().then(res => {
            saveAs(res.body, res.headers.get('content-disposition').replace(/.*filename="(.+?)".*/, '$1'))
        });
    }

    async loadVerificationReportCsv(report: any): Promise<any> {
        let customerId = report.filterProps?.customerId || '',
            locationId = report.filterProps?.locationId || '',
            from = new Date(report.filterProps?.beginDate || beginDate),
            to = new Date(report.filterProps?.endDate || Date.now());
        from.setHours(0, 0, 0, 0);
        to.setHours(23, 59, 59, 999);

        this.httpService.generateVerificationReportCsv(from.getTime(), to.getTime(), customerId, locationId, this.includeServiceMode).toPromise().then(res => {
            saveAs((res.body as Blob), res.headers.get('content-disposition')?.replace(/.*filename="(.+?)".*/, '$1'));
        });
    }

    async generateReport(report: any) {
        return new Promise(async (res, rej) => {
            try {
                if (report.generateContent === 'systemVerificationReportContent') {
                    await this.loadVerificationData(report);
                    res(true);
                } else if (report.generateContent === 'loadDeploymentDetailsReport') {
                    await this.loadDeploymentDetailsReport(report);
                    res(true);
                } else {
                    let content = await (this as any)[report.generateContent](report);
                    if (!Array.isArray(content)) {
                        content = [];
                    }

                    report.pdf = pdfMake.createPdf({
                        info: {
                            title: report.title
                        },
                        content: [
                            buildHeader({
                                _title: report.title,
                                _beginDate: report.filterProps?.beginDate || report.initialFilterProps?.beginDate || beginDate,
                                _endDate: report.filterProps?.endDate || report.initialFilterProps?.endDate || today,
                                _svg: report.svg,
                                _businessName: this.businessName
                            }),
                            ' ',
                            ...content
                        ],
                        footer: footer,
                        ...styles
                    });

                    this.injectIframe(report);
                    report.pdf.getDataUrl((url: any) => {
                        report.iframe.src = url;
                    });

                    res(true);
                }
            } catch (err) {
                rej(err);
            }
        });
    }
}